import { SvgIcon, SvgIconProps } from '@material-ui/core';

const CollapseAllIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <g fill="none" fillRule="evenodd" transform="rotate(180 12.1 12)">
        <polygon points="24 24 0 24 0 0 24 0" opacity=".87" />
        <path
          fill="currentColor"
          fillRule="nonzero"
          d="M15.875,11.6666667 L11.995,15.5466667 L8.115,11.6666667 C7.725,11.2766667 7.095,11.2766667 6.705,11.6666667 C6.315,12.0566667 6.315,12.6866667 6.705,13.0766667 L11.295,17.6666667 C11.685,18.0566667 12.315,18.0566667 12.705,17.6666667 L17.295,13.0766667 C17.685,12.6866667 17.685,12.0566667 17.295,11.6666667 C16.905,11.2866667 16.265,11.2766667 15.875,11.6666667 L15.875,11.6666667 Z"
        />
        <path
          fill="currentColor"
          fillRule="nonzero"
          d="M15.875,6.33333333 L11.995,10.2133333 L8.115,6.33333333 C7.725,5.94333333 7.095,5.94333333 6.705,6.33333333 C6.315,6.72333333 6.315,7.35333333 6.705,7.74333333 L11.295,12.3333333 C11.685,12.7233333 12.315,12.7233333 12.705,12.3333333 L17.295,7.74333333 C17.685,7.35333333 17.685,6.72333333 17.295,6.33333333 C16.905,5.95333333 16.265,5.94333333 15.875,6.33333333 L15.875,6.33333333 Z"
        />
      </g>
    </SvgIcon>
  );
};

export default CollapseAllIcon;
